import axios from './axios'
export default (url, data = {}, method) => {
  return axios({
    url: url,
    method: method,
    data
  })
}



// WEBPACK FOOTER //
// ./src/axios/index.js